import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shared/ui';
import { cn } from '@shared/lib/utils';
import { SUPPORTED_LANGUAGES } from '@shared/i18n/config/languages';
import { persistLanguage } from '@shared/i18n/lib/persist-locale';

interface LocaleThemeControlsProps {
  className?: string;
  iconClassName?: string;
  triggerClassName?: string;
}

export function LocaleThemeControls({
  className,
  iconClassName = 'size-5',
  triggerClassName,
}: LocaleThemeControlsProps) {
  const { t, i18n } = useTranslation('auth');

  const changeLanguage = (value: string) => {
    void i18n.changeLanguage(value);
    persistLanguage(value);
  };

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={cn(
              'size-8 shrink-0 rounded-xl text-muted-foreground hover:text-foreground',
              triggerClassName,
            )}
            aria-label={t('languageMenu')}
          >
            <Globe className={iconClassName} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[10rem]">
          {SUPPORTED_LANGUAGES.map((code) => (
            <DropdownMenuItem
              key={code}
              className="cursor-pointer"
              onSelect={() => changeLanguage(code)}
            >
              {t(`languages.${code}`)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
